import React from "react";
import "./AboutTabContent.css";

const AboutTabmission = () => {
  return (
    <div className="about-tab-contents">
      <h2 className="about-tab-contents-h2">Our mission</h2>
      <p className="about-tab-contents-p">
        We subscribe to the philosophy that “Success breeds Success.” As our
        partners succeed, income is increased, value is created and the long
        term relationship strengthens. We have assisted numerous organizations
        within this region.
      </p>
    </div>
  );
};

export default AboutTabmission;
